module.exports = {
  pathPrefix: '/',
  siteUrl: 'https://codemochi.com',
  siteTitle: 'Code Mochi',
  siteDescription: 'The lost React fullstack deployment video series.',
  author: 'Stephen Jensen',
  postsForArchivePage: 3,
  defaultLanguage: 'en',
  disqusScript: 'https://code-mochi.disqus.com/embed.js',
  pages: {
    home: '/',
    blog: 'blog',
    about: 'about',
    tag: 'tag',
    tos: 'tos',
    'cookie-policy': 'cookie-policy',
    'privacy-policy': 'privacy-policy',
    // archive: 'archive',
  },
  social: {
    github: 'https://github.com/CaptainChemist',
    linkedin: '',
    rss: '/rss.xml',
  },
  tags: {
    amplify: {
      description:
        'A colletion of cloud services useful for making a full stack developers job easier.',
    },
    aws: {
      name: 'AWS',
      description:
        'AWS or Amazon Web Services is the largest cloud provider and provide a large array of services.',
    },
    angular: {
      description: 'Angular is an open source web application platform.',
    },
    auth0: {
      name: 'Auth0',
      description:
        'Auth0 is an authentication and authorization provider as a service.',
    },
    cloudfront: {
      description:
        'Cloudfront is a global content delivery network (CDN) useful for delivering content such as javascript, html, css or videos.',
    },
    docker: {
      description:
        'Docker allows you to run your applications in individual containers that you can build, share and run anywhere.',
    },
    electron: {
      description:
        'Electron is a framework for building cross-platform desktop applications with web technology.',
    },
    gatsby: {
      description:
        'A static site generator for React that is blazingly fast. Useful for websites that are not dynamically changing- such as a blog. (Like this one!)',
    },
    github: {
      description: 'A git repository for storing all your code.',
    },
    graphql: {
      name: 'GraphQL',
      description: 'A query language for your api.',
    },
    graphcms: {
      name: 'GraphCMS',
      description:
        'GraphCMS is Content Management Platform built from the ground up with GraphQL in mind.',
    },
    javascript: {
      description:
        'JavaScript is an object-oriented programming language used alongside HTML and CSS to give functionality to web pages.',
    },
    laravel: {
      description:
        'Laravel is a PHP framework for building web applications following the MVC pattern.',
    },
    less: {
      description:
        'Less is a language extension for CSS. It can do everything CSS can an more like nesting, variables and mixins.',
    },
    nodejs: {
      name: 'Node.js',
      description:
        'Node.js is a tool for executing JavaScript in a variety of environments.',
    },
    nextauth: {
      name: 'NextAuth.js',
      description: 'Authentication for Next.js',
    },
    nextjs: {
      name: 'Next.js',
      description:
        'A React.js framework for easily creating server side web applications.',
    },
    prisma: {
      name: 'Prisma',
      description:
        'Prisma is an ORM replacement which makes writing backend graphQL servers a breeze.',
    },
    now: {
      name: 'Zeit Now',
      description:
        'Zeit Now is a serverless deployment tool to put your website up in an AWS lambda function.',
    },
    rds: {
      name: 'AWS RDS',
      description:
        'RDS is a managed database service provided by AWS that handles backups, monitoring, and scaling.',
    },
    route53: {
      name: 'Route 53',
      description:
        'Route 53 is a scalable and available DNS service provided by AWS.',
    },
    rxjs: {
      name: 'RxJS',
      description:
        'RxJS is a library for reactive programming using Observables, to make it easier to compose asynchronous or callback-based code.',
    },
    s3: {
      description:
        'AWS S3 is highly reliable file storage that is continuously backed up and cheap. Useful for storing assets for web pages.',
    },
    sass: {
      description: 'Sass is a stable extension to classic CSS.',
    },
    saas: {
      description: 'Software as a service.',
    },
    styledcomponents: {
      name: 'styled-components',
      description:
        'A positively delightful way to write your CSS with javascript template literals.',
    },
    typescript: {
      description:
        'TypeScript is a typed superset of JavaScript that compiles to plain JavaScript.',
    },
    react: {
      description:
        'React is an open source JavaScript library used for designing user interfaces.',
    },
    vuejs: {
      name: 'Vue.js',
      description:
        'Vue.js is a JavaScript framework for building interactive web applications.',
    },
  },
}
